import React, { useState } from "react";
import { FaSignInAlt, FaTimes, FaEnvelope, FaLock, FaRocket, FaCheck } from "react-icons/fa";
import api from "../../services/axiosInstance";
import { useNavigate } from "react-router-dom";
import loginBoy from './login-boy.jpg';
const LoginModal = ({ isOpen, onClose, onSwitchToRegister,onSwitchToForgotPassword  }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const res = await api.post("/users/login", { email, password });
      const { accessToken, user, message } = res.data;
  
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("user", JSON.stringify(user));

      setSuccess(message || "Connexion réussie !");
      setLoading(false);

      // Wait 1.5s then navigate or reload
      setTimeout(() => {
        onClose();
        window.location.reload();
      }, 1500);
    } catch (err) {
      console.log("err",err)
      setError(err.response?.data?.message || "Échec de la connexion");
      setLoading(false);
    }
  }; 

  return (
   <div onClick={onClose} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-sm">
  <div onClick={(e) => e.stopPropagation()} className="w-full max-w-5xl max-h-[90vh] lg:max-h-[85vh] overflow-hidden bg-white rounded-2xl shadow-2xl flex flex-col lg:flex-row">
    
    {/* Left Side - Login Form */}
    <div className="w-full lg:w-1/2 p-6 md:p-8 lg:p-10 overflow-y-auto">
      {/* Header - Clean and minimal */}
      <div className="mb-6 md:mb-8 lg:mb-10">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="p-2 rounded-lg bg-emerald-50">
              <FaSignInAlt className="text-lg text-emerald-600" />
            </div>
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-gray-900">Bienvenue</h2>
              <p className="text-sm md:text-base text-gray-600 mt-1">Content de vous revoir !</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 transition-colors rounded-lg hover:text-gray-700 hover:bg-gray-100"
            aria-label="Fermer"
          >
            <FaTimes className="text-xl" />
          </button>
        </div>
      </div>

      {/* Body - Clean form layout */}
      <div className="pt-4">
        <form className="space-y-6" onSubmit={handleSubmit}>
          {/* Email Field */}
          <div>
            <div className="relative">
              <FaEnvelope className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="votre@email.com"
                required
                className="w-full pl-12 pr-4 py-3 md:py-4 text-gray-900 placeholder-gray-500 bg-gray-50 border border-gray-200 rounded-3xl focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 focus:outline-none transition-all duration-200 focus:bg-white text-sm md:text-base"
              />
            </div>
          </div>

          {/* Password Field */}
          <div>
            <div className="relative">
              <FaLock className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Votre mot de passe"
                required
                className="w-full pl-12 pr-4 py-3 md:py-4 text-gray-900 placeholder-gray-500 bg-gray-50 border border-gray-200 rounded-3xl focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 focus:outline-none transition-all duration-200 focus:bg-white text-sm md:text-base"
              />
            </div>
            
            <div className="flex items-center justify-end mt-3 md:mt-4">
              <button
                onClick={() => {
                  onClose();
                  onSwitchToForgotPassword();
                }}
                type="button"
                className="text-sm font-medium text-emerald-600 hover:text-emerald-700 transition-colors"
              >
                Mot de passe oublié ?
              </button>
            </div>
          </div>

          {/* Messages */}
          {error && (
            <div className="px-4 py-3 text-sm bg-red-50 text-red-700 rounded-xl border border-red-100">
              {error}
            </div>
          )}
          {success && (
            <div className="px-4 py-3 text-sm bg-emerald-50 text-emerald-700 rounded-xl border border-emerald-100">
              {success}
            </div>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full px-4 py-3 md:py-4 text-white font-semibold bg-emerald-500 hover:bg-emerald-600 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed rounded-3xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 shadow-md hover:shadow-lg text-sm md:text-base"
          >
            {loading ? (
              <span className="flex items-center justify-center">
                <svg className="w-5 h-5 mr-2 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
                Connexion...
              </span>
            ) : (
              <span className="flex items-center justify-center">
                <FaRocket className="mr-2 md:mr-3" />
                Se connecter
              </span>
            )}
          </button>
        </form>

        {/* Footer - Minimal divider */}
        <div className="relative my-6 md:my-8">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-200"></div>
          </div>
          <div className="relative flex justify-center">
            <span className="px-4 md:px-6 bg-white text-gray-500 text-sm">Pas encore de compte ?</span>
          </div>
        </div>

        {/* Register Link */}
        <div className="text-center">
          <button
            onClick={() => {
              onClose();
              onSwitchToRegister();
            }}
            className="text-sm font-medium text-gray-700 hover:text-emerald-600 transition-colors focus:outline-none focus:underline px-4 py-2 rounded-lg hover:bg-gray-50"
          >
            Inscrivez-vous ici
          </button>
        </div>
      </div>
    </div>

    {/* Right Side - Image Illustration - Hidden on mobile/tablet, visible on lg+ */}
    <div className="hidden lg:block w-1/2 relative overflow-hidden">
      {/* Full cover background image */}
      <div className="absolute inset-0">
        <img 
          src={loginBoy}
          alt="Illustration" 
          className="w-full h-full object-cover"
        />
        {/* Dark gradient overlay for better readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-emerald-700/50 via-emerald-700/40 to-emerald-700/40"></div>
      </div> 
      
      {/* Content container - positioned over the image */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center p-12 text-center">
        <div className="w-full max-w-md space-y-8">
          
          {/* Text content */}
          <div className="space-y-6">
            <div>
              <h3 className="text-4xl font-bold text-white mb-4 leading-tight">
                Rejoignez notre communauté
              </h3>
              <p className="text-xl text-gray-300 font-medium">
                Connectez-vous pour accéder à votre espace personnel
              </p>
            </div>

            {/* Quote/Testimonial */}
            <div className="pt-12 mt-8 border-t border-gray-300/30">
              <p className="text-gray-200 italic text-lg font-medium">
                "La meilleure plateforme pour education"
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-emerald-400 to-transparent"></div>
      <div className="absolute top-10 right-10 w-32 h-32 bg-emerald-500/10 rounded-full blur-2xl"></div>
      <div className="absolute bottom-10 left-10 w-40 h-40 bg-emerald-600/10 rounded-full blur-2xl"></div>
      
      {/* Optional: Add a subtle vignette effect */}
      <div className="absolute inset-0 shadow-[inset_0_0_100px_rgba(0,0,0,0.5)]"></div>
    </div>
  </div>
</div> 
  );
};

export default LoginModal;